import React from 'react';
// @ts-ignore
import styles from './FileSignedBadge.module.scss';
import Text from '../../../../Components/Base/Text/Text';

const FileSignedBadge: React.FC = () => {
	return (
		<div className={styles.wrapper}>
			<img
				src='/dist/icons/file-certificate-regular-full.svg'
				alt='Signature icon'
				height='22px'
			/>{' '}
			<Text tx='component.fileSignedBadge.title' inline />
		</div>
	);
};

export default FileSignedBadge;
